import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { LoginService } from '@uiowa/uiowa-header';

@Component({
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.css']
})
export class AccessDeniedComponent implements OnInit {
  constructor(
    private readonly loginService: LoginService,
    public readonly userService: UserService
  ) {}

  ngOnInit() {}
  login() {
    this.loginService.login();
  }
}
